module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<div class="l-layout__wrapper">\r\n	<div class="l-layout__top"></div>\r\n	<div class="l-layout__content">\r\n		<div class="l-layout__content-side"></div>\r\n		<div class="l-layout__content-main">\r\n            <div class="l-layout__content-controls">\r\n                <button class="js-show-content-side show-filters-button" data-layout-class="show-filters"></button>\r\n            </div>\r\n			<div class="b-matrix-current"></div>\r\n			<div class="b-matrix-nearest"></div>\r\n			<div class="b-tickets-container"></div>\r\n		</div>\r\n	</div>\r\n</div>\r\n';

}
return __p
}